import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { X } from "lucide-react";
import { toast } from "sonner";

export default function AuthDialog({ open, onClose }) {
  const { login, register } = useAuth();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res =
      mode === "login"
        ? await login(email, password)
        : await register(name, email, password);
    setLoading(false);
    if (res.ok) {
      toast.success(mode === "login" ? "Bon retour !" : "Compte créé.");
      onClose();
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div
      data-testid="auth-modal"
      className="fixed inset-0 z-50 grid place-items-center bg-ink/40 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-md bg-linen border border-ink shadow-brut-lg p-8"
      >
        <button
          data-testid="close-auth-button"
          onClick={onClose}
          className="absolute top-4 right-4 p-1.5 hover:bg-ink hover:text-linen transition"
          aria-label="Fermer"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="tape-label text-poppy mb-2">
          {mode === "login" ? "ACCÈS / 01" : "INSCRIPTION / 02"}
        </div>
        <h2 className="font-display font-black text-3xl mb-1">
          {mode === "login" ? "Bon retour." : "Créer un compte."}
        </h2>
        <p className="text-sm text-ink/60 mb-6">
          {mode === "login"
            ? "Retrouvez vos favoris et votre historique."
            : "Sauvegardez vos trouvailles et activez les alertes prix."}
        </p>

        <form onSubmit={submit} className="space-y-3">
          {mode === "register" && (
            <div>
              <label className="tape-label block mb-1.5">Nom</label>
              <input
                data-testid="auth-name-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                placeholder="Alex Dupont"
                className="input-brut w-full px-3 py-2.5 text-sm font-medium"
              />
            </div>
          )}
          <div>
            <label className="tape-label block mb-1.5">Email</label>
            <input
              data-testid="auth-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="vous@exemple.com"
              className="input-brut w-full px-3 py-2.5 text-sm font-medium"
            />
          </div>
          <div>
            <label className="tape-label block mb-1.5">Mot de passe</label>
            <input
              data-testid="auth-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              placeholder="6 caractères min."
              className="input-brut w-full px-3 py-2.5 text-sm font-medium"
            />
          </div>

          <button
            data-testid="auth-submit-button"
            type="submit"
            disabled={loading}
            className="btn-brut w-full py-3 text-sm uppercase tracking-widest disabled:opacity-60"
          >
            {loading ? "…" : mode === "login" ? "Se connecter" : "Créer le compte"}
          </button>
        </form>

        <div className="mt-5 text-center text-sm">
          {mode === "login" ? (
            <button
              data-testid="switch-to-register"
              onClick={() => setMode("register")}
              className="underline decoration-poppy underline-offset-4 font-bold"
            >
              Pas de compte ? S'inscrire
            </button>
          ) : (
            <button
              data-testid="switch-to-login"
              onClick={() => setMode("login")}
              className="underline decoration-poppy underline-offset-4 font-bold"
            >
              Déjà inscrit ? Se connecter
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
